var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "form-group",
        class: { "has-error": _vm.errors.has("actionItem") }
      },
      [
        _c(
          "label",
          {
            staticClass: "col-sm-2 control-label",
            attrs: { for: "actionItem" }
          },
          [_vm._v("Follow up on:")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-8" }, [
          _c("input", {
            directives: [
              {
                name: "validate",
                rawName: "v-validate.disable",
                value: "required",
                expression: "'required'",
                modifiers: { disable: true }
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.timeEntry.actionItem,
                expression: "timeEntry.actionItem"
              }
            ],
            staticClass: "form-control",
            attrs: {
              "data-vv-as": "follow up on",
              type: "text",
              id: "actionItem",
              name: "actionItem",
              placeholder: "What is to be done?",
              maxlength: "50",
              disabled: _vm.timeEntry.isAuditEdit
            },
            domProps: { value: _vm.timeEntry.actionItem },
            on: {
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.timeEntry, "actionItem", $event.target.value)
              }
            }
          }),
          _vm._v(" "),
          _vm.errors.has("actionItem")
            ? _c("p", { staticClass: "text-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("actionItem")))
              ])
            : _vm._e()
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form-group",
        class: { "has-error": _vm.errors.has("followupAdjuster") }
      },
      [
        _c(
          "label",
          {
            staticClass: "col-sm-2 control-label",
            attrs: { for: "followupAdjuster" }
          },
          [_vm._v("Assigned to:")]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-5 col-md-4 col-lg-3" },
          [
            _c("user-picker", {
              directives: [
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "required",
                  expression: "'required'",
                  modifiers: { disable: true }
                }
              ],
              attrs: {
                "data-vv-as": "assigned to",
                name: "followupAdjuster",
                disabled: _vm.timeEntry.isAuditEdit,
                "is-outlook": _vm.isOutlook
              },
              model: {
                value: _vm.timeEntry.followupAdjuster,
                callback: function($$v) {
                  _vm.$set(_vm.timeEntry, "followupAdjuster", $$v)
                },
                expression: "timeEntry.followupAdjuster"
              }
            }),
            _vm._v(" "),
            _vm.errors.has("followupAdjuster")
              ? _c("p", { staticClass: "text-danger" }, [
                  _vm._v(_vm._s(_vm.errors.first("followupAdjuster")))
                ])
              : _vm._e()
          ],
          1
        )
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form-group",
        class: { "has-error": _vm.errors.has("followupDate") }
      },
      [
        _c(
          "label",
          {
            staticClass: "col-sm-2 control-label",
            attrs: { for: "followupDate" }
          },
          [_vm._v("Follow up by:")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-4 col-md-3 col-lg-2" }, [
          _c(
            "div",
            { staticStyle: { "max-width": "150px" } },
            [
              _c("datepicker", {
                directives: [
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true }
                  }
                ],
                attrs: {
                  "data-vv-as": "follow up by",
                  name: "followupDate",
                  "calendar-button": true,
                  "calendar-button-icon": "fa fa-calendar",
                  "clear-button": false,
                  "clear-button-icon": "fa fa-times",
                  "bootstrap-styling": true,
                  format: "yyyy MMM dd",
                  typeable: _vm.isTypeable,
                  disabled: _vm.timeEntry.isAuditEdit
                },
                model: {
                  value: _vm.timeEntry.followupDate,
                  callback: function($$v) {
                    _vm.$set(_vm.timeEntry, "followupDate", $$v)
                  },
                  expression: "timeEntry.followupDate"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.errors.has("followupDate")
            ? _c("p", { staticClass: "text-danger" }, [
                _vm._v(_vm._s(_vm.errors.first("followupDate")))
              ])
            : _vm._e()
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3fa1b52c", { render: render, staticRenderFns: staticRenderFns })
  }
}